const TABS = ["All", "Unread", "Groups"];
 
export default function TabBar({ activeTab, onTabChange, unreadCount }) {
  return (
    <div style={styles.wrapper}>
      {TABS.map((tab) => {
        const isActive = activeTab === tab;
        return (
          <button
            key={tab}
            onClick={() => onTabChange(tab)}
            style={{
              ...styles.tab,
              background: isActive ? "#1a3c5e" : "transparent",
              color:      isActive ? "#fff"    : "#64748b",
              fontWeight: isActive ? 600       : 400,
            }}
          >
            {tab}
            {tab === "Unread" && unreadCount > 0 && (
              <span style={styles.badge}>{unreadCount}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
 
const styles = {
  wrapper: {
    display: "flex",
    gap: 6,
    padding: "8px 12px",
    borderBottom: "1px solid #000000ff",
  },
  tab: {
    display: "flex",
    alignItems: "center",
    gap: 5,
    border: "none",
    borderRadius: 20,
    padding: "5px 14px",
    fontSize: 13,
    cursor: "pointer",
    transition: "all 0.15s",
  },
  badge: {
    background: "#ef4444",
    color: "#fff",
    borderRadius: 10,
    fontSize: 11,
    padding: "1px 6px",
    fontWeight: 700,
  },
};